var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageImprovePurpleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.133,
    height: 12.133,
    viewBox: "0 0 12.133 12.133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161717",
    "data-name": "Group 161717",
    transform: "translate(-0.433 0.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83696",
    "data-name": "Path 83696",
    d: "M21.25,19.625A1.625,1.625,0,1,1,19.625,18,1.626,1.626,0,0,1,21.25,19.625Z",
    transform: "translate(-13.125 -14.208)",
    fill: "none",
    stroke: "#a80ced",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83697",
    "data-name": "Path 83697",
    d: "M16.667,12.333A4.333,4.333,0,1,1,12.333,8,4.332,4.332,0,0,1,16.667,12.333Z",
    transform: "translate(-5.833 -6.917)",
    fill: "none",
    stroke: "#a80ced",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83698",
    "data-name": "Path 83698",
    d: "M24,4V5.083",
    transform: "translate(-17.5 -4)",
    fill: "none",
    stroke: "#a80ced",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83699",
    "data-name": "Path 83699",
    d: "M24,40v1.083",
    transform: "translate(-17.5 -30.25)",
    fill: "none",
    stroke: "#a80ced",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83700",
    "data-name": "Path 83700",
    d: "M40,24h1.083",
    transform: "translate(-29.167 -18.583)",
    fill: "none",
    stroke: "#a80ced",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83701",
    "data-name": "Path 83701",
    d: "M4,24H5.083",
    transform: "translate(-2.917 -18.583)",
    fill: "none",
    stroke: "#a80ced",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageImprovePurpleIcon);
export default __webpack_public_path__ + "static/media/message-improve-purple-icon.63ebd1e7c95bfef4e19baba08b724e04.svg";
export { ForwardRef as ReactComponent };